import React, { Component, Fragment } from "react";
import { observer, inject } from "mobx-react";
import ModalContainer from "../../modal/ModalContainer";

import { DialogContent,Divider, DialogActions,Typography, Button, Grid, TextField,Switch} from "@material-ui/core";
import moment from "moment";

@inject("agentVenueStore", "profileStore", "templateStore")
@observer
class AgentVenueUpdateIncludeSuper extends Component {
    sigCanvas = {};
    state = {
        isLoading: false,
        isSwitchOn: false
    }


    componentDidUpdate(prevProps) {
        if (prevProps.open !== this.props.open) {
            var data = this.props.data
            this.setState({
                isSwitchOn: data?.defaultIncludeSuper
            })
        }
    }

    handleSwitchOn = e => this.setState({isSwitchOn: !this.state.isSwitchOn})   

    onClose = () => {
        // this.props.agentVenueContactStore.reset()
        this.props.onClose()
    }

    handleSubmit = () => {
        var currentProfile = this.props.profileStore.getCurrentProfile()
       this.props.templateStore.showLoadingScreen();
       this.props.agentVenueStore.updateDefaultIncludeSuper(this.props.data?.id, this.state.isSwitchOn, currentProfile?.id).then(() => {
             this.props.templateStore.hideLoadingScreen();
                this.props.templateStore.openSnackbar(`${this.props.data?.venue ? this.props.data.venue.profileName : "Venue"}'s default setting for including super has been updated.`);
                this.props.onSave(this.state.isSwitchOn)
                localStorage.setItem(`resetAgentVenueRoster`, true);
       })
    };


    
    render() {
        const {isSwitchOn} = this.state
        const { open, onClose, data } = this.props;

        return (
            <ModalContainer open={open} onClose={onClose} onEntered={this.onEntered} fullScreen={false} maxWidth="sm" title={`${data?.venue ? data.venue.profileName : "Venue"} - Booking Super Configuration Default`} coloredDialogTitle={true}>
                <DialogContent>
                    <Grid container spacing={8}>
                        <Grid item xs={12} md={12}>
                            <Grid item xs={12} md={12}>
                                <Switch checked={isSwitchOn} onChange={this.handleSwitchOn} value="hideToolbar" /> Performance fee includes super for all bookings
                            </Grid>
                            <Typography component="span" variant="p" style={{marginLeft:15, fontSize:11}}>
                                When enabled, this will automatically treat the performance fee as inclusive of superannuation for all sole trader bookings.
                            </Typography>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.onClose}>Close</Button>
                    <Button id="btn-confirm-processbooking" onClick={this.handleSubmit} color="primary" className="process-booking">
                        Save
                    </Button>
                </DialogActions>
            </ModalContainer>
        );
    }
}

export default AgentVenueUpdateIncludeSuper;
